/**
 * isiZulu: Menu and frame
 *
 * What this file covers: The side menu, its section headings, the top bar, the profile menu and the frame
 * around every page.
 *
 * Tone: One or two words per item, like a sign on a door. Nouns, not sentences. Every label must fit a narrow
 * menu. The words chosen here are the names of the pages everywhere else.
 *
 * isiZulu: Everyday isiZulu as used in South African business. Keys not translated yet fall back to English, so
 * a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const menu: Catalog = {
  'nav.section.workspace': 'Indawo yokusebenza',
  'nav.section.audience': 'Izethameli',
  'nav.section.automation': 'Ukuzenzakalela',
  'nav.section.settings': 'Izilungiselelo',
  'nav.section.account': 'I-akhawunti',
  'nav.dashboard': 'Ideshibhodi',
  'nav.inbox': 'Ibhokisi lokungenayo',
  'nav.contacts': 'Oxhumana nabo',
  'nav.broadcasts': 'Ukusakaza',
  'nav.templates': 'Izifanekiso',
  'nav.flows': 'Ukugeleza',
  'nav.numbers': 'Izinombolo',
  'nav.billing': 'Ukukhokhisa',
  'nav.settings': 'Izilungiselelo',
  'nav.menu': 'Imenyu',
  'shell.org.tooltip': 'Inhlangano yakho. Vula izilungiselelo zenhlangano.',
  'nav.openMenu': 'Vula ukuzulazula',
  'nav.closeMenu': 'Vala ukuzulazula',
  'shell.wallet.aria': 'Ibhalansi yesikhwama {{amount}}. Vula ukukhokhisa.',
  'nav.developers': 'Onjiniyela',
  'nav.channels': 'Iziteshi'
};

export default menu;
